module.exports = __webpack_public_path__ + "img/PreviousAdmin.49ac203a.svg";